import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../route.animation';
import {FormBuilder, Validators} from '@angular/forms';
import {GeneralService} from '../../../_services/general.service';
import {Languages} from '../../../_interfaces/languages';
import {Countries} from '../../../_interfaces/countries';
import {FormsService} from '../../../_services/forms.service';
import {Subscription} from 'rxjs/Subscription';
import {ClientsService} from '../../../_services/clients.service';
import {ActivatedRoute, Params} from '@angular/router';
import {Client} from '../../../_interfaces/clients/clients';
import {PreviousUrlService} from '../../../_services/previous-url.service';
import {debounceTime, tap} from 'rxjs/operators';
import {ApiService} from '../../../_interceptors/api.service';
import {PageTitleService} from '../../../_services/page-title.service';
import {environment} from '../../../../environments/environment';

@Component({
	selector: 'app-clients-edit',
	templateUrl: './clients-edit.component.html',
	styleUrls: ['./clients-edit.component.scss'],
	animations: [routeAnimation]
})

export class ClientsEditComponent implements OnInit, OnDestroy {

	@HostBinding('@routeAnimation') routerTransition = true;

	// noinspection JSMismatchedCollectionQueryUpdate
	public languages: Languages[] = [];
	// noinspection JSMismatchedCollectionQueryUpdate
	public countries: Countries[] = [];
	// noinspection JSMismatchedCollectionQueryUpdate
	public countriesFiltered: Countries[] = [];

	public isLoadingCountries: boolean = false;

	public client_id: number = null;
	public dataLoaded: boolean = false;
	public missingData: Array<string> = [];

	public clientsEditForm = this.formBuilder.group({
		company_name: ['', [Validators.required, Validators.maxLength(50)]],
		language_id: ['', Validators.required],
		language_name: [''],
		address: ['', [Validators.required, Validators.maxLength(100)]],
		postalcode: ['', [Validators.required, Validators.maxLength(10)]],
		city: ['', [Validators.required, Validators.maxLength(50)]],
		country_id: ['', Validators.required],
		country_id_filterString: [''],
		country_name: [''],
		telephone: ['', [Validators.maxLength(20)]],
		email: ['', [Validators.required, Validators.email]]
	});

	private _errorsSubscription: Subscription = null;
	private _activatedRouteSubscription: Subscription = null;

	constructor(private generalService: GeneralService,
				public clientsService: ClientsService,
				public formsService: FormsService,
				private activatedRoute: ActivatedRoute,
				private previousUrlService: PreviousUrlService,
				private apiService: ApiService,
				private formBuilder: FormBuilder,
				private pageTitleService: PageTitleService) {
	}

	ngOnInit(): void {
		this.apiService.connectionChanged.subscribe(online => {
			if (online && this.missingData.length > 0) {
				this.missingData = [];
				this.loadData();
			}
		});
		this.formsService.form = this.clientsEditForm;

		this.previousUrlService.setPreviousUrlIfNull('/clients');

		this._errorsSubscription = this.clientsService.errors.subscribe(errors => {
			this.formsService.processErrors(errors);
		});

		this.clientsEditForm
			.get('country_id_filterString')
			.valueChanges
			.pipe(
				debounceTime(300),
				tap(() => this.isLoadingCountries = true)
			)
			.subscribe(value => {
				if (typeof value === 'string') {
					if (value !== '' && value !== null) {
						const val = value.toLowerCase();
						this.countriesFiltered = this.countries.filter(data => data.country_name.toLowerCase().indexOf(val) !== -1);
						this.isLoadingCountries = false;
					} else if (value !== null) {
						this.countriesFiltered = this.countries.slice();
						this.isLoadingCountries = false;
					}
				} else {
					this.isLoadingCountries = false;
				}
			});

		this._activatedRouteSubscription = this.activatedRoute.params.subscribe((params: Params) => {
			this.client_id = parseInt(params['client_id'], 10);

			this.clientsService.getClient(this.client_id).then((client: Client) => {
				if (typeof client !== 'undefined') {
					this.pageTitleService.setTitle(client.company_name + ' | Klant aanpassen | ' + environment.webappName);
					this.pageTitleService.setPageTitle(client.company_name);
				}
			});

			this.loadData();
		});
	}

	ngOnDestroy(): void {
		if (this._activatedRouteSubscription !== null) {
			this._activatedRouteSubscription.unsubscribe();
		}

		if (this._errorsSubscription !== null) {
			this._errorsSubscription.unsubscribe();
		}
	}

	loadData() {
		this.generalService.getLanguages().then((languages: Languages[]) => {
			if (languages !== null && languages.length) {
				this.languages = languages;

				this.clientsEditForm.get('language_id').enable();
			} else {
				this.missingData.push('Taal');
				this.clientsEditForm.get('language_id').disable();
			}
		}).catch(error => console.log(error));

		this.generalService.getCountries().then((countries: Countries[]) => {
			if (countries !== null && countries.length) {
				this.countries = countries;
				this.countriesFiltered = countries;

				this.clientsEditForm.get('country_id').enable();
			} else {
				this.missingData.push('Land');
				this.clientsEditForm.get('country_id').disable();
			}
		});

		this.clientsService.getClient(this.client_id).then((client: Client) => {
			this.formsService.populateForm(client);

			this.dataLoaded = true;
		});
	}

	setLanguageName(language_name: string) {
		this.clientsEditForm.get('language_name').setValue(language_name);
	}

	setCountryName(country_name: string) {
		this.clientsEditForm.get('country_name').setValue(country_name);
	}
}
